import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { AuthService } from '../_services/auth.service';

/**
 * Admin guard - only allows access to admin users
 * Redirects to emails page if user is not an admin
 */
export const adminGuard: CanMatchFn = async () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Check if user is admin
  if (authService.isAdmin) {
    return true;
  }

  // Not admin - redirect to emails
  router.navigate(['/emails']);
  return false;
};
